import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const ADMIN_ANALYZER_DETAILS_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
